import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";
import api, { formatApiErrorDetail } from "../lib/api";
import { useI18n } from "../i18n/I18nContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [link, setLink] = useState(null);
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      if (data.reset_link) setLink(data.reset_link);
      toast.success(t("send_link"));
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F4F8FC]">
      <div className="w-full max-w-sm df-rise">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <h2 className="font-head text-2xl font-bold text-[#0D253F]">{t("forgot_title")}</h2>
        <p className="text-[#627D98] mt-1 mb-6">{t("forgot_sub")}</p>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>{t("email")}</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" /></div>
          <Button type="submit" disabled={loading} className="w-full h-12 bg-[#1A73E8] hover:bg-[#1557B0] text-white font-semibold" data-testid="forgot-submit">
            {loading ? t("loading") : t("send_link")}
          </Button>
        </form>
        {link && (
          <div className="mt-4 rounded-xl p-3 text-sm break-all" style={{ background: "#FEF7E0", border: "1px solid #FDE293", color: "#8a5a00" }} data-testid="forgot-link-box">
            <p className="font-semibold mb-1">{t("email_not_connected")}</p>
            <Link to={new URL(link).pathname + new URL(link).search} className="text-[#1557B0] underline">{link}</Link>
          </div>
        )}
        <p className="text-center mt-4 text-sm"><Link to="/login" className="text-[#1A73E8] font-semibold">{t("back")}</Link></p>
      </div>
    </div>
  );
}
